__turbopack_context__.v({
  "blingBanner": "wFYiJW_blingBanner",
  "blingBannerContent": "wFYiJW_blingBannerContent",
  "blingBannerFrame": "wFYiJW_blingBannerFrame",
  "blingCta": "wFYiJW_blingCta",
  "blingPricing": "wFYiJW_blingPricing",
  "blingStartsFrom": "wFYiJW_blingStartsFrom",
  "blingTaxNote": "wFYiJW_blingTaxNote",
  "blingTextCol": "wFYiJW_blingTextCol",
  "blingTitle": "wFYiJW_blingTitle",
  "featuredBanner": "wFYiJW_featuredBanner",
  "featuredSleepingMask": "wFYiJW_featuredSleepingMask" + " " + "wFYiJW_featuredBanner",
  "featuredStrikedPrice": "wFYiJW_featuredStrikedPrice",
  "heroBanner": "wFYiJW_heroBanner",
});
